/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TwitterInputs */

const en_twitter = /** @type {(inputs: TwitterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twitter`)
};

const de_twitter = /** @type {(inputs: TwitterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twitter`)
};

/**
* | output |
* | --- |
* | "Twitter" |
*
* @param {TwitterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const twitter = /** @type {((inputs?: TwitterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TwitterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_twitter(inputs)
	return de_twitter(inputs)
});